import { useMemo } from 'react'

import { PreFillType } from '@constants'
import { FormType } from '@types'

type UsePreFillConfigParams = {
  formConfig?: FormType
  preFillFromAnotherObject?: PreFillType
}

export type PreFillConfig = {
  hasPreFillField: boolean
  preFill: PreFillType | undefined
}
/**
 * Хук для определения конфигурации предварительного заполнения формы
 *
 * @returns {PreFillConfig}
 * - hasPreFillField: есть ли в форме поля с preFill
 * - preFill: данные для предзаполнения (если нужны)
 */
export const usePreFillConfig = ({
  formConfig,
  preFillFromAnotherObject,
}: UsePreFillConfigParams): PreFillConfig => {
  const hasPreFillField = useMemo(
    () => Boolean(formConfig?.fields?.some(field => field.preFill)),
    [formConfig?.fields]
  )

  const preFill = useMemo((): PreFillType | undefined => {
    // Если в форме нет полей с preFill, то preFill не нужен
    if (!hasPreFillField) {
      return undefined
    }

    // Если есть предварительное заполнение из другого объекта (родительского), используем его
    if (preFillFromAnotherObject) {
      return preFillFromAnotherObject
    }

    // Иначе используем пустые параметры для предзаполнения по форме
    return {
      objectCode: undefined,
      objectId: undefined,
    }
  }, [hasPreFillField, preFillFromAnotherObject])

  return {
    hasPreFillField,
    preFill,
  }
}
